<div class="flex flex-col p-6 max-w-md">
    <div class="flex items-start">
        <div class="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full bg-amber-100 text-amber-600">
            <mat-icon [svgIcon]="'heroicons_outline:exclamation'"></mat-icon>
        </div>
        <div class="ml-4 flex-1">
            <div class="text-lg font-semibold">You're already signed in on another device</div>
            <div class="mt-1 text-sm text-secondary">
                Only one active sign-in is allowed per account. Continuing here will
                sign the other device out.
            </div>
        </div>
    </div>

    <div class="mt-5 rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 p-4 text-sm">
        <div class="grid grid-cols-3 gap-y-2">
            <div class="text-secondary">Device</div>
            <div class="col-span-2 font-medium">{{ prettyUserAgent }}</div>

            <div class="text-secondary">IP address</div>
            <div class="col-span-2 font-medium">{{ prettyIpAddress }}</div>

            <div class="text-secondary">Last active</div>
            <div class="col-span-2 font-medium">{{ lastSeenRelative || 'Just now' }}</div>
        </div>
    </div>

    <div class="mt-6 flex items-center justify-end gap-2">
        <button mat-button type="button" (click)="cancel()">
            Cancel
        </button>
        <button mat-flat-button type="button" color="warn" (click)="confirm()">
            <mat-icon class="mr-1 icon-size-5" [svgIcon]="'heroicons_outline:logout'"></mat-icon>
            Sign out the other device
        </button>
    </div>
</div>
